export default __webpack_public_path__ + "static/media/Woulda Square Look Nice.37d5ab42.png";